export default function ClearMapButton({ level }) {
  return (
    <button
      className="secondary-ui-button"
      onClick={() => {
        level.editor.clearPlacements();
      }}
    >
      Clear Map
    </button>
  );
}
